"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BecropStats = void 0;
class BecropStats {
    constructor(obj) {
        this.mean = obj.mean || -1;
        this.min = obj.min || -1;
        this.max = obj.max || -1;
        this.pixels_data = obj.pixels_data || null;
        this.q_25 = obj.q_25 || -1;
        this.q_50 = obj.q_50 || -1;
        this.q_75 = obj.q_75 || -1;
    }
}
exports.BecropStats = BecropStats;
